// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"0dd12b59","453":"f907893c","495":"87692cf0","706":"8a2f8a4c","728":"21a56505","840":"ecc9f158","879":"338a1906","968":"4a57771f"}[chunkId] + ".chunk.js";
};